// extracted by mini-css-extract-plugin
export default {"componentWrapper":"PageTitle_componentWrapper__c0Z-e","backArrow":"PageTitle_backArrow__dnwW-","title":"PageTitle_title__IoBlW","thin":"PageTitle_thin__t3AAH"};